import type { Theme } from '@mui/material/styles';
import { SnackType } from '@/features/snacks/enums/SnackType';

export const getSnackTextColor = (theme: Theme, type: SnackType) => {
  switch (type) {
    case SnackType.Error:
      return theme.palette.error.dark;
    case SnackType.Warning:
      return theme.palette.warning.dark;
    case SnackType.Info:
      return theme.palette.accent.primary;
    default:
      return theme.palette.success.dark;
  }
};
